<div :class="['container-fluid bg-white p-0', !liveness_photo && !submitting_data ? 'vh-100' : 'min-vh-100']">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Comprehensive Liveness Verification" />

    <!-- Submission Loader (shown during final data submission) -->
    <div v-if="submitting_data" class="d-flex flex-column align-items-center justify-content-center min-vh-50 w-100">
      <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Submitting...</span>
      </div>
      <p class="text-muted fw-semibold">Submitting your verification data...</p>
      <p class="text-muted text-xs">Please wait, this may take a moment.</p>
    </div>

    <!-- OCR Document Reader (shown after liveness is verified) -->
    <div v-else-if="liveness_photo" class="d-flex justify-content-center align-items-start pt-3 min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <div class="d-flex align-items-center md-3">
          <span><i class="text-muted bi bi-question-circle me-2"></i></span>
          <span class="text-muted text-xs">OCR verification is a thorough validation process that ensures the accuracy, authenticity, and compliance of submitted information.</span>
        </div>
        <OCRComponent @document-processed="handleDocumentProcessed" @scan-started="handleScanStarted" />
      </div>
    </div>

    <!-- Facial Biometrics (shown first) -->
    <FacialBiometricsComponent v-else @set-liveness-data="set_liveness_data" />
</div>